import React from 'react'
import {SoldOutBodyMessage} from 'components/SearchUnavailability/SoldOut/SoldOutBodyMessage'

import {Button} from '@daedalus/atlas/Button'
import {Card} from '@daedalus/atlas/Card'
import ContentWrapper from '@daedalus/atlas/helpers/ContentWrapper'
import {Flex} from '@daedalus/atlas/helpers/Flex'
import {Icon} from '@daedalus/atlas/Icon'
import {Text} from '@daedalus/atlas/Text'
import {FormattedMessageWrapper} from '@daedalus/core/src/localization/components/FormattedMessage'

interface Props {
  handleChangeDatesClick?: (event: React.MouseEvent) => void
}

export const RoomsSectionSoldOut: React.FC<Props> = ({
  handleChangeDatesClick
}) => {
  return (
    <ContentWrapper paddingTop="s500">
      <Card
        borderRadius="lg"
        borderColorPath="border.neutral.c200"
        dataId="roomsSectionSoldOut"
      >
        <ContentWrapper paddingY="s700" paddingX="s600">
          <Flex.Column alignItems="center" justifyContent="center" gap="s300">
            <Flex.Row gap="s200" alignItems="center">
              <Icon size="md" name="Forbid" colorPath="content.danger.c500" />
              <Text variant="titleL">
                <FormattedMessageWrapper
                  id="unavailability.soldout"
                  defaultMessage="Sold out on your dates"
                />
              </Text>
            </Flex.Row>
            <Text>
              <SoldOutBodyMessage />
            </Text>
            {handleChangeDatesClick && (
              <ContentWrapper paddingTop="s300">
                <Button
                  size="xl"
                  variant="secondary"
                  onClick={handleChangeDatesClick}
                  dataId="roomsSectionSoldOutChangeDatesButton"
                >
                  <FormattedMessageWrapper
                    id="changeDates"
                    defaultMessage="Change dates"
                  />
                </Button>
              </ContentWrapper>
            )}
          </Flex.Column>
        </ContentWrapper>
      </Card>
    </ContentWrapper>
  )
}
